/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useCallback } from "react";
import { IInspectorControl_Add, TInspectorControlProps } from "../InspectorControlTypes";
import { FieldGroup, FieldWrapper } from "@adapptio/lib-editor-ui";
import { FieldActionButton } from "@adapptio/lib-editor-ui/src/components/fields/FieldActionButton";
import { isSchemaConstArrayModel, isSchemaConstMapModel } from "@adapptio/lib-blueprint";

export interface IInspectorControlAddProps extends TInspectorControlProps<IInspectorControl_Add> {}

export const InspectorControlAdd: React.FC<IInspectorControlAddProps> = ({ model }) => {
	const handleAdd = useCallback(() => {
		if (isSchemaConstArrayModel(model)) {
			model.schema.addElement(model, undefined, true);
		}

		if (isSchemaConstMapModel(model)) {
			model.schema.addElement(model, model.schema.getUniqueKey(model, "#", true), undefined, true);
		}
	}, [ model ]);

	return (
		<FieldGroup>
			<FieldWrapper type="add">
				<FieldActionButton iconName="mdi/plus" onClick={handleAdd} />
			</FieldWrapper>
		</FieldGroup>
	);
};
